import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import {
  ErrorTypes,
  ValidationError,
  formatBreakTime,
} from 'modules/attendance/lib/validateShiftBreakDurationRules'

interface Props {
  errors: ValidationError[]
  shiftLengthInMinutes: number
  onClose: () => void
  onReview: () => void
  onSave: () => void
}

const TimeInconsistenciesAlert = ({
  errors,
  shiftLengthInMinutes,
  onClose,
  onReview,
  onSave,
}: Props) => {
  const errorMessage = errors[errors.length - 1]
  const { minimalDuration = 0 } = errorMessage ?? {}
  const remainingMinutes = minimalDuration - shiftLengthInMinutes

  useEffect(() => {
    const pathname = window.location.href.includes('attendance') ? 'attendance' : 'dashboard'
    track(trackingEvents.timeTracking.inconsistenciesModalDisplayed, {
      path_name: pathname,
      inconsistencies_type: errorMessage?.error,
    })
  }, [])

  if (!errorMessage || remainingMinutes <= 0) {
    return null
  }

  let secondaryButtonCopy = i18n.t('time_tracking.modals.rest_time_alerts.save_shift')
  let primaryButtonCopy = i18n.t('time_tracking.modals.rest_time_alerts.review_fix_shift')
  let title = i18n.t('time_tracking.modals.rest_time_alerts.rest_time_title')
  let description = i18n.t('time_tracking.modals.rest_time_alerts.min_rest_time_description', {
    break_duration: minimalDuration,
    hours_worked: formatBreakTime(errorMessage.periodLength ?? 0),
  })

  if (errorMessage.error === ErrorTypes.BREAK_MINIMUM) {
    secondaryButtonCopy = i18n.t('time_tracking.modals.rest_time_alerts.save_break')
    primaryButtonCopy = i18n.t('time_tracking.modals.rest_time_alerts.review_fix_break')
    title = i18n.t('time_tracking.modals.rest_time_alerts.break.title')
    description = i18n.tp('time_tracking.modals.rest_time_alerts.break.description', {
      min_break_duration: minimalDuration,
      remaining_minutes: remainingMinutes,
      count: remainingMinutes,
    })
  }

  const handleOnClose = () => {
    track(trackingEvents.timeTracking.inconsistenciesModalActionTaken, {
      modal_type: 'time inconsistencies modal',
      action: 'cancel',
    })
    onClose()
  }

  const handleOnSave = () => {
    track(trackingEvents.timeTracking.inconsistenciesModalActionTaken, {
      modal_type: 'time inconsistencies modal',
      action: 'save',
    })
    onSave()
  }

  const handleOnReview = () => {
    track(trackingEvents.timeTracking.inconsistenciesModalActionTaken, {
      modal_type: 'time inconsistencies modal',
      action: 'review',
    })
    onReview()
  }

  return (
    <Modal
      illustration="alert"
      title={title}
      description={description}
      onClose={handleOnClose}
      footer={
        <Box flexDirection="row" alignItems="flexEnd" gap="s8" style={{ zIndex: '1500' }}>
          <Button type="secondary" onClick={() => handleOnSave()}>
            {secondaryButtonCopy}
          </Button>
          <Button type="primary" onClick={() => handleOnReview()}>
            {primaryButtonCopy}
          </Button>
        </Box>
      }
    ></Modal>
  )
}

export default TimeInconsistenciesAlert
